import { memo } from "react"

const IconWebhooks = () => {
  return (
    <svg
      stroke="#6062CB"
      fill="none"
      stroke-width="2"
      viewBox="0 0 24 24"
      stroke-linecap="round"
      stroke-linejoin="round"
      color="#6062CB"
      height="24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc></desc>
      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
      <path d="M4.876 13.61a4 4 0 1 0 6.124 3.39h6"></path>
      <path d="M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5"></path>
      <path d="M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5"></path>
    </svg>
  )
}

export default memo(IconWebhooks)
